/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Effort_EasyInputs */

const en_us2_workout_quick_effort_easy = /** @type {(inputs: Workout_Quick_Effort_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easy`)
};

const pt_br2_workout_quick_effort_easy = /** @type {(inputs: Workout_Quick_Effort_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leve`)
};

const es_419_workout_quick_effort_easy = /** @type {(inputs: Workout_Quick_Effort_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fácil`)
};

const pt_pt2_workout_quick_effort_easy = /** @type {(inputs: Workout_Quick_Effort_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leve`)
};

const fr_fr2_workout_quick_effort_easy = /** @type {(inputs: Workout_Quick_Effort_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facile`)
};

const de_de2_workout_quick_effort_easy = /** @type {(inputs: Workout_Quick_Effort_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leicht`)
};

const it_it2_workout_quick_effort_easy = /** @type {(inputs: Workout_Quick_Effort_EasyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facile`)
};

/**
* | output |
* | --- |
* | "Easy" |
*
* @param {Workout_Quick_Effort_EasyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_effort_easy = /** @type {((inputs?: Workout_Quick_Effort_EasyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Effort_EasyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_effort_easy(inputs)
	if (locale === "es-419") return es_419_workout_quick_effort_easy(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_effort_easy(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_effort_easy(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_effort_easy(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_effort_easy(inputs)
	return en_us2_workout_quick_effort_easy(inputs)
});
export { workout_quick_effort_easy as "workout-quick.effort_easy" }